import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from './LockedContentView.module.scss';
import LockedContent, { LockedContentProps } from '../LockedContent';

const cx = classNames.bind(styles);

const LockedContentView = ({ title, content }: LockedContentProps): ReactElement => {
  return (
    <div className={cx('body')} data-testid="locked-content-view">
      <div className={cx('container')}>
        <LockedContent title={title} content={content} />
      </div>
    </div>
  );
};

export default LockedContentView;
